import React, { useState } from 'react';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { TableInput } from '../../../../../../../../components/common';
import CustomSelect from '../../../../../../../../components/common/SelectField';
import { DateTimePicker } from '@mui/x-date-pickers';
import { MenuItem } from '@mui/material';
import moment from 'moment';
import { useAuth } from '../../../../../../../../services/auth/AuthProvider';

interface IProps {
  moduleData: any;
  isView: boolean;
}

const allowedEditUsers = [
  "6630b1321433a777c3031e7b", // lalit
  "66349cf12d0f294182dea252", // mushin-admin
];

const TBody = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  const { state } = useAuth();
  const canEdit = allowedEditUsers.includes(state.user?._id || '');

  return (
    <tbody>
      {moduleData &&
        moduleData?.c1?.map((process: any, index: number) => (
          <tr>
            <td>{index + 1}</td>
            <td style={{ minWidth: '300px', textAlign: 'center' }}>
              {process.loot_at}
            </td>
            <td style={{ minWidth: '300px', textAlign: 'center' }}>
              {process.look_for}
            </td>
            <td style={{ minWidth: '120px', textAlign: 'center' }}>
              <TableInput
                isView={isView}
                name="obs1"
                type="text"
                value={process.obs1}
                onChange={(e) => {
                  handleChangeModuleData(e, process);
                  const newValue = e.target.value;
                  if (!process.obs1FirstAt && newValue && newValue.trim().length > 0) {
                    process.obs1FirstAt = new Date().toISOString();
                  }
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td style={{ minWidth: '180px', width: '180px' }}>
              {canEdit && !isView ? (
                <DateTimePicker
                  ampm={false}
                  format="DD/MM/YYYY HH:mm"
                  value={process.obs1FirstAt ? moment(process.obs1FirstAt) : null}
                  onChange={(dateTime: any) => {
                    process.obs1FirstAt = dateTime ? moment(dateTime).seconds(0).milliseconds(0).toISOString() : null;
                    setRender((prev) => !prev);
                  }}
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: { width: 220, backgroundColor: '#f8f9fa' },
                    },
                  }}
                />
              ) : process.obs1FirstAt ? (
                <span style={{ display: 'inline-block', width: '180px' }}>
                  {new Date(process.obs1FirstAt).toLocaleString()}
                </span>
              ) : (
                <span style={{ display: 'inline-block', width: '180px' }}></span>
              )}
            </td>
            <td style={{ minWidth: '120px', textAlign: 'center' }}>
              <TableInput
                isView={isView}
                name="obs2"
                type="text"
                value={process.obs2}
                onChange={(e) => {
                  handleChangeModuleData(e, process);
                  const newValue = e.target.value;
                  if (!process.obs2FirstAt && newValue && newValue.trim().length > 0) {
                    process.obs2FirstAt = new Date().toISOString();
                  }
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td style={{ minWidth: '180px', width: '180px' }}>
              {canEdit && !isView ? (
                <DateTimePicker
                  ampm={false}
                  format="DD/MM/YYYY HH:mm"
                  value={process.obs2FirstAt ? moment(process.obs2FirstAt) : null}
                  onChange={(dateTime: any) => {
                    process.obs2FirstAt = dateTime ? moment(dateTime).seconds(0).milliseconds(0).toISOString() : null;
                    setRender((prev) => !prev);
                  }}
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: { width: 220, backgroundColor: '#f8f9fa' },
                    },
                  }}
                />
              ) : process.obs2FirstAt ? (
                <span style={{ display: 'inline-block', width: '180px' }}>
                  {new Date(process.obs2FirstAt).toLocaleString()}
                </span>
              ) : (
                <span style={{ display: 'inline-block', width: '180px' }}></span>
              )}
            </td>
            <td style={{ minWidth: '120px', textAlign: 'center' }}>
              <TableInput
                isView={isView}
                name="obs3"
                type="text"
                value={process.obs3}
                onChange={(e) => {
                  handleChangeModuleData(e, process);
                  const newValue = e.target.value;
                  if (!process.obs3FirstAt && newValue && newValue.trim().length > 0) {
                    process.obs3FirstAt = new Date().toISOString();
                  }
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td style={{ minWidth: '180px', width: '180px' }}>
              {canEdit && !isView ? (
                <DateTimePicker
                  ampm={false}
                  format="DD/MM/YYYY HH:mm"
                  value={process.obs3FirstAt ? moment(process.obs3FirstAt) : null}
                  onChange={(dateTime: any) => {
                    process.obs3FirstAt = dateTime ? moment(dateTime).seconds(0).milliseconds(0).toISOString() : null;
                    setRender((prev) => !prev);
                  }}
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: { width: 220, backgroundColor: '#f8f9fa' },
                    },
                  }}
                />
              ) : process.obs3FirstAt ? (
                <span style={{ display: 'inline-block', width: '180px' }}>
                  {new Date(process.obs3FirstAt).toLocaleString()}
                </span>
              ) : (
                <span style={{ display: 'inline-block', width: '180px' }}></span>
              )}
            </td>
            <td style={{ minWidth: '100px', textAlign: 'center' }}>
              {isView ? (
                process.status
              ) : (
                <CustomSelect
                  name="status"
                  value={process.status}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                >
                  <MenuItem value="">NONE</MenuItem>
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOT OK">NOT OK</MenuItem>
                </CustomSelect>
              )}
            </td>
          </tr>
        ))}
    </tbody>
  );
};

export default TBody;
